export const serverPort = 8090;
export const mongo_url = "mongodb://apiuser:gbPU8aOO2OqhlNbX@localhost:27017";
export const db_name = "sne-pro";
export const base_url = "https://snepro-api.vistaura.in";



// WEBPACK FOOTER //
// /root/production/sne-pro/server/src/config/config.ts